/* eslint-disable react-hooks/exhaustive-deps */

import TaxCode from "../../components/TaxCode";

const AdminTaxCode = (props) => {
    return (
        <TaxCode moduleType={'Admin'} {...props} />
    )
}

export default AdminTaxCode